import { render, staticRenderFns } from "./HistoryOrder.vue?vue&type=template&id=0229dae3&scoped=true&"
import script from "./HistoryOrder.vue?vue&type=script&lang=js&"
export * from "./HistoryOrder.vue?vue&type=script&lang=js&"
import style0 from "./HistoryOrder.vue?vue&type=style&index=0&id=0229dae3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0229dae3",
  null
  
)

export default component.exports